/** @format */

import React, { PropsWithChildren } from "react";
import { useAppSelector } from "../../app/hooks";
import Formattedtext from "../formattedText/FormattedText";
import { selectIsPrintable } from "../printable/printableSlice";

import "./GlossaryTerms.scss";
import { Tooltip, TooltipContent, TooltipTrigger } from "./Tooltip";

type Props = {
  tooltip: string;
};

const GlossaryTerms: React.FC<PropsWithChildren<Props>> = ({
  children,
  tooltip,
}) => {
  const isPrintable = useAppSelector(selectIsPrintable());

  return (
    <>
      {!isPrintable && (
        <Tooltip>
          <TooltipTrigger>
            <span className="glossary-term">{children}</span>
          </TooltipTrigger>
          <TooltipContent className="glossary-term-tooltip">
            <Formattedtext html={tooltip} />
          </TooltipContent>
        </Tooltip>
      )}
      {/* Tooltip is displayed for print version.*/}
      <span
        className={`glossary-term-tooltip position-absolute ${
          isPrintable ? "d-inline" : "d-none"
        }`}
      >
        <Formattedtext html={tooltip} />
      </span>
    </>
  );
};

export default GlossaryTerms;
